import { Href } from "../../../../../Constant";
import { LI, UL } from "../../../../../AbstractElements";
import { useAppDispatch } from "../../../../../Redux-Toolkit/Hooks";
import { setColView } from "../../../../../Redux-Toolkit/Reducers/FilterSlice";
import { FILTER_PRODUCT_DATA } from "../../../../../Data/Ecommerce";

export const GridOptions = () => {
  const dispatch = useAppDispatch();
  const LayoutView = (colClass: string) => dispatch(setColView(colClass));

  return (
    <div className="grid-options d-inline-block">
      <UL className="simple-list">
        {FILTER_PRODUCT_DATA.map((data, index) => (
          <LI key={index}>
            <a className={`product-${data.id}-layout-view`} href={Href} onClick={() => LayoutView(data.colClass)}>
              {data.filterData.map((item, number) => (
                <span key={number} className={`line-grid line-grid-${item} bg-primary`}></span>
              ))}
            </a>
          </LI>
        ))}
      </UL>
    </div>
  );
};
